import React, { useEffect, useState } from "react";

import { DatosQuiz, QuizCompleto } from "../../../../services/v2/lmsQuiz.service";
import { Icono, mensajeDeError } from "../comun";
import { puntosTxt } from "../tareas/comunTareas";
import { AjustesDelQuiz, CambioQuiz, datosDeForma, formaDeQuiz, PreguntasQuiz, QuizForma, revisarForma, totalDeForma } from "./editorQuiz";
import "./quiz.css";

/*
	Preguntas de un quiz del curso o del módulo (Catálogo › Cursos › Contenido, Parte D). Todos los horarios que lo heredan reciben
	las preguntas al instante (es la misma fila); si ya hay intentos entregados, guardar los vuelve a calificar. Un quiz que viene
	del curso, visto desde el módulo, solo se mira.
*/

interface Props
{
	titulo: string
	cargar: () => Promise<QuizCompleto>
	guardar: (d: DatosQuiz) => Promise<QuizCompleto>
	subirImagen?: (f: File) => Promise<string>
	onCerrar: (guardado: boolean) => void
}

const PanelPreguntas: React.FC<Props> = ({ titulo, cargar, guardar, subirImagen, onCerrar }) => {
	const [quiz, setQuiz] = useState<QuizCompleto | null>(null)
	const [forma, setForma] = useState<QuizForma | null>(null)
	const [error, setError] = useState<string | null>(null)
	const [guardando, setGuardando] = useState<boolean>(false)
	const [subiendo, setSubiendo] = useState<number>(0)
	const [firmaInicial, setFirmaInicial] = useState<string | null>(null)
	const cambiar = (c: CambioQuiz) => setForma((f) => (f ? (typeof c === "function" ? c(f) : c) : f))

	useEffect(() => {
		cargar().then((q) => { const f = formaDeQuiz(q); setQuiz(q); setForma(f); setFirmaInicial(JSON.stringify(datosDeForma(f))) }).catch((e) => setError(mensajeDeError(e, "No pudimos abrir las preguntas.")))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const cambiado = !!forma && firmaInicial !== null && JSON.stringify(datosDeForma(forma)) !== firmaInicial
	const cerrar = () => {
		if (cambiado && !window.confirm("¿Cerrar sin guardar? Se pierden los cambios a las preguntas.")) return
		onCerrar(false)
	}
	const enviar = async () => {
		if (!forma || !quiz || guardando || subiendo > 0) return
		const p = revisarForma(forma)
		if (p) { setError(p); return }
		if (quiz.hasAttempts && !window.confirm("Ya hay alumnos que entregaron este quiz. Al guardar se vuelven a calificar todos (en todos los horarios) contra estas preguntas. ¿Guardar?")) return
		setGuardando(true); setError(null)
		try { await guardar(datosDeForma(forma)); onCerrar(true) } catch (e) { setError(mensajeDeError(e)); setGuardando(false) }
	}

	const soloLectura = !!quiz && !quiz.editable
	return (
		<div className="pcTarjeta" style={{ gap: 14, background: "var(--pc-hover)" }}>
			<div className="pcFilaAutor">
				<span className="pcAv" style={{ width: 40, height: 40, borderRadius: 12, background: "var(--pc-acento-tinte)", color: "var(--pc-acento-texto)" }} aria-hidden="true"><Icono n="pregunta" size={20} /></span>
				<div className="pcAutorTextos">
					<div className="pcAutorNombre" style={{ overflowWrap: "anywhere" }}>Preguntas · {titulo}</div>
					<div className="pcTenue pcChico">{quiz ? [quiz.originLabel, forma ? puntosTxt(totalDeForma(forma)) + " Pts En Total" : null].filter(Boolean).join(" · ") : "Cargando…"}</div>
				</div>
				<button type="button" className="pcIb" aria-label="Cerrar" onClick={cerrar}><Icono n="cerrar" /></button>
			</div>
			{soloLectura ? <div className="pcNota">Este quiz viene del curso: aquí solo se mira. Sus preguntas se cambian en el curso.</div> : null}
			{forma && forma.preguntas.length === 0 ? <div className="tkAvisoOro">Agrega al menos una pregunta para que los grupos lo vean.</div> : null}
			{quiz?.hasAttempts && !soloLectura ? <div className="tkAvisoOro">Ya hay alumnos que lo entregaron: si cambias preguntas o puntos, al guardar se vuelven a calificar todos.</div> : null}
			{error && !forma ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
			{forma ? (
				<>
					<AjustesDelQuiz forma={forma} onCambio={cambiar} soloLectura={soloLectura} />
					<PreguntasQuiz forma={forma} onCambio={cambiar} soloLectura={soloLectura} subirImagen={subirImagen} onSubiendo={(v) => setSubiendo((n) => Math.max(0, n + (v ? 1 : -1)))} />
					{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
					{!soloLectura ? (
						<div className="pcRedactorPie"><div className="pcDerecha">
							<button type="button" className="pcBtn pcBtnS" onClick={cerrar}>Cancelar</button>
							<button type="button" className="pcBtn pcBtnP" disabled={guardando || subiendo > 0} onClick={enviar}>Guardar Preguntas</button>
						</div></div>
					) : null}
				</>
			) : !error ? <div className="pcCargando">Cargando…</div> : null}
		</div>
	)
}

export default PanelPreguntas
